import type { ComponentType, ReactNode } from "react";
import { Suspense, lazy } from "react";

import { SegmentsPageLoader } from "app/pages/segments/segmentsPageLoader";

const Loader = () => <SegmentsPageLoader />;

function withSuspense<P extends object>(Component: ComponentType<P>, fallback: ReactNode = <Loader />) {
    return function SuspendedComponent(props: P) {
        return (
            <Suspense fallback={fallback}>
                <Component {...props} />
            </Suspense>
        );
    };
}

export function lazyWithSuspense<P extends object = object>(
    importFunc: () => Promise<{ default: ComponentType<P> }>,
    fallback?: ReactNode,
) {
    const LazyComponent = lazy(importFunc);
    return withSuspense(LazyComponent, fallback);
}
